module.exports = __webpack_public_path__ + "img/sm-facebook.fb1b56c9.svg";